import { LIST_BILLINGS } from '@/data/actions/modules/financial';
import { UPDATE_BRANCH } from '@/data/actions/modules/general';

const meta = {
  layout: 'master',
  requiresAuth: true,
  permission: LIST_BILLINGS,
};

export default [
  {
    path: '/financial/billing-batches',
    component: () => import(/* webpackChunkName: "billing-batches" */ './components/Main.vue'),
    meta,
  },
  {
    path: '/financial/billing-batches/new',
    component: () => import(/* webpackChunkName: "billing-batches" */ './components/Main.vue'),
    meta,
  },
  {
    path: '/financial/billing-batches/settings',
    component: () => import(/* webpackChunkName: "billing-batches" */ './components/Settings.vue'),
    meta: { ...meta, permission: UPDATE_BRANCH },
  },
  {
    path: '/financial/billing-batches/:id',
    component: () => import(/* webpackChunkName: "billing-batches" */ './components/BatchDetail.vue'),
    meta,
  },
];
